import React from "react";
import { connect } from 'react-redux';
import { clearItem, removeItem, addItem } from '../../redux/cart/cart.actions'

import "./CheckoutItem.styles.scss";

const CheckoutItem = ({cartItem, clearItem, removeItem, addItem}) => {
  const { name, imageUrl, price, quantity } = cartItem;
  return (
    <div className="checkout-item">
      <div className="image-container">
        <img alt="product" src={imageUrl} />
      </div>

      <span className="name">{name}</span>
      <span className="quantity">

        <div className="arrow" onClick={() => removeItem(cartItem)}>&#10094;</div>
        <span className="value"> {quantity} </span>
        <div className="arrow" onClick={() => addItem(cartItem)}>&#10095;</div>

        </span>

      <span className="price">{price}</span>
      <div className="remove-button" onClick={() => clearItem(cartItem)}>&#10005;</div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  clearItem: cartItem => dispatch(clearItem(cartItem)),
  addItem: cartItem => dispatch(addItem(cartItem)),
  removeItem: cartItem => dispatch(removeItem(cartItem))
})

export default connect(null, mapDispatchToProps)(CheckoutItem);
